import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Alert, Modal, Form, Row, Col } from "react-bootstrap";
import { Paper, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

// import ForumIcon from '@material-ui/icons/Forum';
import { Formik } from "formik";
import * as Admin from "../../../store/ducks/admin.duck";
import * as Yup from "yup";
import { ToastContainer, Flip } from "react-toastify";
import FormDataEntry from "../admin/FormDataEntry";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../_metronic/_assets/css/app.css";
import "../../../../_metronic/_assets/css/app2.css";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

export default function CSClientClose(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const thisClient = useSelector((state) => state.admin.CSClient);
  const [showSurveyForm, setShowSurveyForm] = useState(false);
  const [surveyType, setSurveyType] = useState("");
  const [surveyFormData, setSurveyFormData] = useState(null);
  const [surveyCompleted, setSurveyCompleted] = useState(false);

  const initClientClose = useMemo(
    () => ({
      initalAssessment: "K10",
      consumerExperienceSurvey: "",
      reasonClosure: "",
      closureFinalAssessment: thisClient.closureInitialAssessment || "Not SpecK10",
      newScoreType: "K10",
      hasClosureAssessment: false,
      id: 0,
    }),
    [],
  );

  var [client, setClient] = useState(initClientClose);

  function handleClose() {
    // Go back to client list
    history.push("/csclients");
  }

  useEffect(() => {
    setClient({
      ...initClientClose,
      ...thisClient,
    });
  }, [thisClient, initClientClose]);

  function putCloseClient(data) {
    // Alters client to Closed status and sends survey in the API
    const payload = {
      id: thisClient.id,
      firstname: thisClient.firstname,
      email: thisClient.email,
      mobilephone: thisClient.mobilephone,
      notificationPreference: thisClient.notificationPreference,
      reasonClosure: data.reasonClosure || "",
      closureExperienceRating: data.closureExperienceRating || 0,
      consumerExperienceSurvey: data.consumerExperienceSurvey || "",
      closureFinalAssessment: data.closureFinalAssessment || "Not Specified",
      hasClosureAssessment: data.hasClosureAssessment || false,
      formData: surveyFormData || null,
    };

    // ---------- DISPATCH ----------
    dispatch(Admin.actions.putCSClientCloseV2(payload));
    // Need to add page to come back to after close
    history.push("/csclients");
  }

  const displaySurvey = (type) => {
    setSurveyType(type);
    setShowSurveyForm(true);
  };

  const handleSurveyComplete = (data) => {
    setSurveyFormData(data);
    setSurveyCompleted(true);
    setShowSurveyForm(false);
  };

  const validationSchema = Yup.object().shape({
    reasonClosure: Yup.string()
      .required("Please select a reason for closure")
      .oneOf(["1", "2", "3", "4", "5", "6", "7", "8"], "Please select a valid reason for closure"),

    consumerExperienceSurvey: Yup.string().when("closureExperienceRating", {
      is: (value) => value === 1 || value === "1" || value === 2 || value === "2",
      then: (schema) => schema.required("Please select a completion method").oneOf(["OnScreen", "Online"], "Please select a valid completion method"),
      otherwise: (schema) => schema.notRequired(),
    }),

    closureFinalAssessment: Yup.string().when(["closureExperienceRating", "hasClosureAssessment"], {
      is: (rating, hasAssessment) => (rating === 2 || rating === "2") && !hasAssessment,
      then: (schema) => schema.required("Please select an outcome measure").oneOf(["K10", "K5"], "Please select a valid outcome measure"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  return (
    <>
      <p>
        You are closing this referral to the Centralised Service for{" "}
        <strong>
          {thisClient.firstname} {thisClient.surname}
        </strong>
      </p>
      <p>Please complete the information below to finalise this action:</p>
      <Formik
        enableReinitialize={true}
        initialValues={client}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          putCloseClient(values);
          // actions.setSubmitting(false);
        }}
      >
        {(props) => {
          const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched } = props;
          const change = (name, e) => {
            e.persist();
            handleChange(e);
          };
          const surveyRequired =
            (values.closureExperienceRating === 1 || values.closureExperienceRating === 2) && values.consumerExperienceSurvey === "OnScreen";

          const closeDisabled = surveyRequired && !surveyCompleted;
          return (
            <>
              <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
                  <Row>
                    <Col md="6">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>Reason for Closure</Form.Label>
                        <Form.Control
                          as="select"
                          name="reasonClosure"
                          value={values.reasonClosure}
                          onChange={change.bind(null, "reasonClosure")}
                          isInvalid={touched.reasonClosure && !!errors.reasonClosure}
                        >
                          <option value="">-- Please select a reason --</option>
                          <option value="1">Service Complete</option>
                          <option value="2">Transferred to in-centre support</option>
                          <option value="3">Transferred to an external service</option>
                          <option value="4">Discharged from the Medicare Mental Health Centre</option>
                          <option value="5">No longer suitable for telehealth</option>
                          <option value="6">Service did not proceed</option>
                          <option value="7">Consumer disengaged</option>
                          <option value="8">Other</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors.reasonClosure}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  {thisClient.closureExperienceRating === 1 ? (
                    <>
                      <h5>Consumer Experience Survey</h5>
                      <p>
                        We collect consumer feedback to improve our service. This is also an important reporting requirement. Our brief consumer experience
                        survey can be sent to consumers via email. Please select the best delivery options below:
                      </p>
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <Form.Label>Select completion method *</Form.Label>
                            <Form.Control
                              as="select"
                              name="consumerExperienceSurvey"
                              value={values.consumerExperienceSurvey}
                              onChange={change.bind(null, "consumerExperienceSurvey")}
                              isInvalid={touched.consumerExperienceSurvey && !!errors.consumerExperienceSurvey}
                            >
                              <option value="">-- Please select a completion method --</option>
                              <option value="OnScreen">Display onscreen for completion</option>
                              <option value="Online">Email to client for completion</option>
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">{errors.consumerExperienceSurvey}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        {values.consumerExperienceSurvey === "OnScreen" ? (
                          <>
                            <Col md="4" style={{ paddingTop: "26px" }}>
                              <Form.Group>
                                {surveyCompleted ? (
                                  <Button variant="outline-success" onClick={() => displaySurvey("Survey")}>
                                    Survey Completed
                                  </Button>
                                ) : (
                                  <Button variant="primary" onClick={() => displaySurvey("Survey")}>
                                    Complete Survey On Screen
                                  </Button>
                                )}
                              </Form.Group>
                            </Col>
                          </>
                        ) : null}
                      </Row>
                    </>
                  ) : null}
                  {thisClient.closureExperienceRating === 2 ? (
                    <>
                      <h5>Consumer Experience Survey and Assessments</h5>
                      <p>
                        We collect consumer feedback to improve our service and outcome data to assess the impact of psychological therapy. This is also an
                        important reporting requirement. These surveys can be sent to consumers via email. Please select the best delivery options below
                      </p>
                      {values.hasClosureAssessment ? (
                        <>
                          <Alert variant="info">
                            <div>
                              A closure K10 or K5 assessment has been completed for this client. Please select how the Consumer Experience Survey will be
                              completed.
                            </div>
                          </Alert>
                          <Row>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Select completion method *</Form.Label>
                                <Form.Control
                                  as="select"
                                  name="consumerExperienceSurvey"
                                  value={values.consumerExperienceSurvey}
                                  onChange={change.bind(null, "consumerExperienceSurvey")}
                                  isInvalid={touched.consumerExperienceSurvey && !!errors.consumerExperienceSurvey}
                                >
                                  <option value="">-- Please select a completion method --</option>
                                  <option value="OnScreen">Display onscreen for completion</option>
                                  <option value="Online">Email to client for completion</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">{errors.consumerExperienceSurvey}</Form.Control.Feedback>{" "}
                              </Form.Group>
                            </Col>
                            {values.consumerExperienceSurvey === "OnScreen" ? (
                              <>
                                <Col md="4" style={{ paddingTop: "26px" }}>
                                  <Form.Group>
                                    {surveyCompleted ? (
                                      <Button variant="outline-success">Survey Completed</Button>
                                    ) : (
                                      <Button variant="primary" onClick={() => displaySurvey("Survey")}>
                                        Complete Survey On Screen
                                      </Button>
                                    )}
                                  </Form.Group>
                                </Col>
                              </>
                            ) : null}
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Select Assessment Measure</Form.Label>
                                <Form.Control
                                  as="select"
                                  name="closureFinalAssessment"
                                  value={values.closureFinalAssessment}
                                  onChange={change.bind(null, "closureFinalAssessment")}
                                  isInvalid={touched.closureFinalAssessment && !!errors.closureFinalAssessment}
                                >
                                  <option value="">-- Please select Assessment Measure --</option>
                                  <option value="K10">K10 Assessment</option>
                                  <option value="K5"> K5 Assessment</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">{errors.closureFinalAssessment}</Form.Control.Feedback>{" "}
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Select completion method *</Form.Label>
                                <Form.Control
                                  as="select"
                                  name="consumerExperienceSurvey"
                                  value={values.consumerExperienceSurvey}
                                  onChange={change.bind(null, "consumerExperienceSurvey")}
                                  isInvalid={touched.consumerExperienceSurvey && !!errors.consumerExperienceSurvey}
                                >
                                  <option value="">-- Please select a completion method --</option>
                                  <option value="OnScreen">Display onscreen for completion</option>
                                  <option value="Online">Email to client for completion</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">{errors.consumerExperienceSurvey}</Form.Control.Feedback>{" "}
                              </Form.Group>
                            </Col>
                            {values.consumerExperienceSurvey === "OnScreen" ? (
                              <>
                                <Col md="4" style={{ paddingTop: "26px" }}>
                                  <Form.Group>
                                    {surveyCompleted ? (
                                      <Button variant="outline-success">Survey Completed</Button>
                                    ) : (
                                      <Button variant="primary" onClick={() => displaySurvey(values.closureFinalAssessment)}>
                                        Complete Survey On Screen
                                      </Button>
                                    )}
                                  </Form.Group>
                                </Col>
                              </>
                            ) : null}
                          </Row>
                        </>
                      )}
                    </>
                  ) : null}
                </Paper>
                {values.consumerExperienceSurvey === "OnScreen" && !surveyCompleted ? (
                  <Alert variant="warning" className="mb-3">
                    <strong
                      style={{
                        display: "block",
                        marginBottom: "8px",
                      }}
                    >
                      Survey still required:
                    </strong>
                    <div>&nbsp;&nbsp;&nbsp;Please complete the consumer experience survey before closing this client.</div>
                  </Alert>
                ) : surveyCompleted ? (
                  <Alert variant="success" className="mb-3">
                    <strong
                      style={{
                        display: "block",
                        marginBottom: "8px",
                      }}
                    >
                      Survey completed:
                    </strong>
                    <div>
                      &nbsp;&nbsp;&nbsp; The consumer experience survey has been completed. You can now click Close Client to save the survey/Assessment and
                      close the client.
                    </div>
                  </Alert>
                ) : null}
                <Row className="mt-4">
                  <Col className="d-flex justify-content-end">
                    <Button variant="outline-secondary" size="lg" style={{ marginRight: "16px" }} onClick={handleClose}>
                      Cancel
                    </Button>
                    <Button variant="primary" size="lg" type="submit" disabled={closeDisabled}>
                      Close Client
                    </Button>{" "}
                  </Col>
                </Row>
              </form>
            </>
          );
        }}
      </Formik>

      <Modal show={showSurveyForm} onHide={() => setShowSurveyForm(false)} dialogClassName="edit-md-sm-dialog-modal">
        <Modal.Header className="edit-md-sm-modal">
          <Modal.Title>Survey Form</Modal.Title>
          <Button
            variant="outlined"
            size="sm"
            style={{
              marginTop: 5,
              background: "#eeeeee",
              border: "1px solid #9da8e5",
              padding: 5,
              marginLeft: 10,
            }}
            onClick={() => setShowSurveyForm(false)}
          >
            <CloseIcon />
          </Button>
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          {surveyType === "Survey" ? (
            <FormDataEntry
              key={14362}
              formID={14362}
              formDataID={0}
              setShowFormData={setShowSurveyForm}
              setFormData={handleSurveyComplete}
              survey={true}
              contextName="CloseSurvey"
              contextID={thisClient && thisClient.id}
            />
          ) : (
            <>
              {surveyType === "K10" ? (
                <FormDataEntry
                  key={14947}
                  formID={14947}
                  formDataID={0}
                  setShowFormData={setShowSurveyForm}
                  setFormData={handleSurveyComplete}
                  survey={true}
                  contextName="CloseSurvey"
                  contextID={thisClient && thisClient.id}
                />
              ) : (
                <FormDataEntry
                  key={14948}
                  formID={14948}
                  formDataID={0}
                  setShowFormData={setShowSurveyForm}
                  setFormData={handleSurveyComplete}
                  survey={true}
                  contextName="CloseSurvey"
                  contextID={thisClient && thisClient.id}
                />
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
